import { ExchangeRates } from '../types/exchangeRates';

type ExchangeRatesResult = ExchangeRates | void;

export const fetchExchangeRates = async () : Promise<ExchangeRatesResult> => {
  const uri = `${process.env.REACT_APP_SERVER_URL}/exchange_rates`;

  try {
    const response = await fetch(uri, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const rates = await response.json();

    return rates as ExchangeRates;
  } catch (error) {
    console.error(error);
  }
};
